import { useEffect } from "react";
import {
  Nav,
  Hero,
  TrustStrip,
  LogoStripV2,
  DevelopmentOverview,
  HeroVideoV2,
  HowItWorksV2,
  ServicesGridV2,
  HorizontalFeatures,
  MarketingCreativeV2,
  MarketingPinnedV2,
  CaseStudiesV2,
  Testimonials,
  FAQ,
  FinalCTA,
  Blog,
  Footer,
} from "../App";

/**
 * HomeV2 — experimental variant.
 * Clone of V1. Diverge freely: reorder sections, swap components,
 * build V2-only subcomponents in this file (or alongside it).
 */
export default function HomeV2() {
  useEffect(() => {
    document.title = "Sunday Digital — V2";
  }, []);

  return (
    <div
      data-testid="home-page"
      data-variant="v2"
      className="min-h-screen bg-[#0B0F14] text-neutral-100 font-body"
    >
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <LogoStripV2 />
        <DevelopmentOverview />
        <HeroVideoV2 />
        <HowItWorksV2 />
        <ServicesGridV2 />
        {/* <HorizontalFeatures /> — hidden on V2 per request; still used on V1/V3/V4 */}
        <MarketingPinnedV2 />
        <MarketingCreativeV2 />
        <CaseStudiesV2 />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <Blog />
      </main>
      <Footer />
    </div>
  );
}
